import Button from 'common/components/button'

type Props = {
  onClick: () => void
  'data-testid': string
}

const AdvancedLanguageCancelButton = ({
  onClick,
  'data-testid': dataTestId,
}: Props) => {
  return (
    <Button onClick={onClick} data-testid={dataTestId} variant="icon">
      Cancel
    </Button>
  )
}

export default AdvancedLanguageCancelButton
